import React from 'react';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import style from '../../style.module.css';

export const LoadingBody = () => {
  return (
    <ModalBody className={style['modal-body']}>
      <LoadingIndicator />
    </ModalBody>
  );
};
